import React, { Component, Fragment } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import Selectsearch from "react-select";
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import {  
    allStudents,
    deleteRangeWedgePlay,
    deleteRangeChipping,
    deleteRangeBunkerPlay,
    getRangeWedgePlay,
    getRangeChipping,
    getRangeBunkerPlay,
    fetchRangeWedgePlay,
    fetchRangeChipping,
    fetchRangeBunkerPlay,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class RangeShortGame extends Component {
   
    constructor(props) {
       
        super(props);
            this.confirmationDialog = React.createRef();
            this.state = {
                student:'',
                eid:'',
                seldate:'',
                viewdiv:false,              
                adddiv:false,
                editdiv:false,
                selfrom:0,
            };  

        this.onBackSection = this.onBackSection.bind(this);  
        this.deleteForm = this.deleteForm.bind(this);
    }

    UNSAFE_componentWillMount() {
		this.props.allStudents();        
	}    

    selstudent(evt){
        var student=evt.value;
        var startdate="";
        var enddate="";
        this.setState({ 
            student: student,
            viewdiv:false,
            adddiv:false,
            editdiv:false,                      
        }); 
        
        this.props.fetchRangeWedgePlay(student, startdate, enddate);
        this.props.fetchRangeChipping(student, startdate, enddate);
        this.props.fetchRangeBunkerPlay(student, startdate, enddate);
        this.setState({ 
            student: student, 
            viewdiv:true,
        });
    }   

    onAddSession(seltid) {
		this.setState({
         selfrom:seltid,   
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
    } 
   

    onBackSection(){
        this.setState({ 
            viewdiv:true,
            adddiv:false,
            editdiv:false
        }); 
    }

    editAssessment(gid,selid){
        var student=this.state.student;
        console.log(student);
        if(selid==1){
            this.props.getRangeWedgePlay(gid).then((data) => {   
                var resdata=data.data;
                this.setState({ 
                    eid:resdata[0].griID,
                    seldate:resdata[0].gri_date,
                    selfrom:selid      
                });  
                
                this.setState({ 
                    viewdiv:false,               
                    adddiv:false,
                    editdiv:true,   
                  });

            });
        }else if(selid==2){
            this.props.getRangeChipping(gid).then((data) => {   
                var resdata=data.data;
                this.setState({ 
                    eid:resdata[0].griID,
                    seldate:resdata[0].gri_date,
                    selfrom:selid     
                });   
                
                this.setState({ 
                    
                    viewdiv:false,               
                    adddiv:false,
                    editdiv:true,   
                  });

            });
            
        }else if(selid==3){
            this.props.getRangeBunkerPlay(gid).then((data) => {   
                var resdata=data.data;
                this.setState({ 
                    eid:resdata[0].griID,
                    seldate:resdata[0].gri_date,
                    selfrom:selid     
                });   
                
                this.setState({ 
                    
                    viewdiv:false,               
                    adddiv:false,
                    editdiv:true,   
                  });

            });
        }

        
    }

    deleteForm(data, selfrm){
      this.data = data;
      this.selfrm = selfrm;
      this.confirmationDialog.current.openDialog();
     
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            var stid=this.state.student;
            var selfrm=this.selfrm;
            if(selfrm==1){
                this.props.deleteRangeWedgePlay(this.data, stid);
            }else if(selfrm==2){
                this.props.deleteRangeChipping(this.data, stid);
            }else if(selfrm==3){
                this.props.deleteRangeBunkerPlay(this.data, stid);
            }
            this.data = ""
        }
    }
        
    
    render() {
        const { match, studentlists, rangewedgeplaylist, rangechippinglist, rangebunkerplaylist, loading } = this.props;       
        const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
        });

        const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "date", label: "DATE" },
            { name: "coach", label: "COACH" },
            { name: "obsert", label: "OBSERVATION" },
            { name: "work", label: "WORK IN PROGRESS" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];

        const tabledata1=rangewedgeplaylist.map((assmntval,idx) => {     
            const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.griID,1)}><EditOutlinedIcon/></IconButton>;
            const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.griID,1)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
       
            return {
                no:idx+1,
                date: assmntval.cdate,
                coach: assmntval.gri_coachname,
                obsert:assmntval.gri_observation,
                work:assmntval.gri_workinprocess,
                action: ebtn,
                action1:dbtn,       
            }
        });

        const tabledata2=rangechippinglist.map((assmntval,idx) => {     
            const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.griID,2)}><EditOutlinedIcon/></IconButton>;
            const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.griID,2)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
       
            return {
                no:idx+1,
                date: assmntval.cdate,
                coach: assmntval.gri_coachname,
                obsert:assmntval.gri_observation,
                work:assmntval.gri_workinprocess,
                action: ebtn,
                action1:dbtn,       
            }
        });

        const tabledata3=rangebunkerplaylist.map((assmntval,idx) => {     
            const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.griID,3)}><EditOutlinedIcon/></IconButton>;
            const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.griID,3)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
       
            return {
                no:idx+1,
                date: assmntval.cdate,
                coach: assmntval.gri_coachname,
                obsert:assmntval.gri_observation,
                work:assmntval.gri_workinprocess,
                action: ebtn,
                action1:dbtn,       
            }
        });

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Short Game Range Intervention| {AppConfig.appTitle}</title>
                <meta name="description" content="Golf Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.rangeshort" />} match={match} />

                <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard> 
                                <div className="row">                                        
                                    <div className="col-sm-12 col-md-12"> 
                                        <FormGroup>
                                            <Label for="Select">Student *</Label>
                                            <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                        </FormGroup>
                                    </div>
                                      
                                </div>
                            </RctCollapsibleCard>  
                        </div>
                </div>

                {this.state.viewdiv &&   
                   <>                          
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="WEDGE PLAY" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(1)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Wedge Play Intervention</Button></div>}
                                data={tabledata1}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="CHIPPING" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(2)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Chipping Intervention</Button></div>}
                                data={tabledata2}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="BUNKER PLAY" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(3)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Bunker Play Intervention</Button></div>}
                                data={tabledata3}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    </>
                } 

                {this.state.adddiv && 

                    <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.editdiv && 

                    <UpdateItems onClick={this.onBackSection} data={this.state}/>
                }

                <ConfirmationDialog
                    ref={this.confirmationDialog}
                    onConfirm={(res) => this.deleteDataPermanent(res)}
                    data={'record'}
                    />
          </div>
       )
    }
 }
 
 const mapStateToProps = ({ mostlyused, rangeshortgame}) => {
    const { studentlists, loading } = mostlyused;
    const { rangewedgeplaylist, rangechippinglist, rangebunkerplaylist } = rangeshortgame;
	return { studentlists, rangewedgeplaylist, rangechippinglist, rangebunkerplaylist, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    deleteRangeWedgePlay,
    deleteRangeChipping,
    deleteRangeBunkerPlay,
    getRangeWedgePlay,
    getRangeChipping,
    getRangeBunkerPlay,
    fetchRangeWedgePlay,
    fetchRangeChipping,
    fetchRangeBunkerPlay
})(RangeShortGame); 